export default __webpack_public_path__ + "img/allergy-soy.8bd4eaea6ba7acde582afc5eda7e91ad.svg";